import React, { FC } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import getPicture from "../../GetPicture";

import { Picture } from "../../model/picture";
import SariaHeader from "../../components/molecules/Header";

import { Card, Container, Image } from "semantic-ui-react";

type Props = {} & RouteComponentProps<{ id: string }>;

const PictureDetail: FC<Props> = ({ history, location, match }) => {
  const id = match.params.id;
  const picture: Picture = getPicture(id);
  return (
    <>
      <SariaHeader></SariaHeader>
      <Container style={{ marginTop: "7em " }}>
        <Card>
          <Image src={picture.image_url}></Image>
          <Card.Content>
            <Card.Header>{picture.emotion} pt.</Card.Header>
          </Card.Content>
        </Card>
      </Container>
    </>
  );
};

export default withRouter(PictureDetail);
